import { httpClient } from '../http';
import { ExportAllLogsQueryParams } from './types';

export const exportAllLogs = async (queryParams: ExportAllLogsQueryParams) => {
	const { data } = await httpClient.get<string>(`/logs/export/all-logs/`, {
		params: queryParams,
		responseType: 'blob',
	});

	return data;
};
